import GroupingsReducer from "./GroupingsReducer.js";
import AggLoader from "./AggLoader.js";
import Map from "./map/PluginSetup.js";
import GoogleMap from "./googleMap/PluginSetup.js";
import DataViewers from "./dataViewers/PluginSetup.js";
const install = molten => {
  molten.addPlugin('DynamicStore.Reducer', GroupingsReducer.createDynamicReducer());
  molten.addPlugin('DataViewer', AggLoader.createPlugin());
  Map.install(molten);
  GoogleMap.install(molten);
  DataViewers.install(molten);
};
export default {
  install
};